export const SCREEN_EXPORT_PADDING = 20
export const LEGEND_BORDER_SIZE = 3

const LEGEND_BORDER_FILL_STYLE = "grey"

export function buildScreenExportLayout({genogramWidth, genogramHeight, legendWidth, legendHeight}) {
	let padding = SCREEN_EXPORT_PADDING
	let legendLeft = genogramWidth + padding * 2
	let legendTop = padding

	return {
		padding,
		width: genogramWidth + legendWidth + padding * 3,
		height: Math.max(genogramHeight, legendHeight) + padding * 2,
		legendLeft,
		legendTop,
		legendWidth,
		legendHeight,
		legendBorderSize: LEGEND_BORDER_SIZE,
	}
}

export function buildGenogramOnlyExportLayout({genogramWidth, genogramHeight}) {
	return {
		padding: 0,
		width: genogramWidth,
		height: genogramHeight,
		legendLeft: 0,
		legendTop: 0,
		legendWidth: 0,
		legendHeight: 0,
		legendBorderSize: LEGEND_BORDER_SIZE,
	}
}

export function getLegendBorderRects(layout = {}) {
	let left = layout.legendLeft || 0
	let top = layout.legendTop || 0
	let width = layout.legendWidth || 0
	let height = layout.legendHeight || 0
	let borderSize = layout.legendBorderSize || LEGEND_BORDER_SIZE

	return [
		{
			left: left - borderSize,
			top: top - borderSize,
			width: width + borderSize * 2,
			height: borderSize,
		},
		{
			left: left - borderSize,
			top: top + height,
			width: width + borderSize * 2,
			height: borderSize,
		},
		{
			left: left - borderSize,
			top: top - borderSize,
			width: borderSize,
			height: height + borderSize * 2,
		},
		{
			left: left + width,
			top: top - borderSize,
			width: borderSize,
			height: height + borderSize * 2,
		},
	]
}

export function drawLegendBorderToCanvas(ctx, layout = {}) {
	let rects = getLegendBorderRects(layout)
	ctx.fillStyle = LEGEND_BORDER_FILL_STYLE

	for (let rect of rects) {
		ctx.fillRect(rect.left, rect.top, rect.width, rect.height)
	}
}
